import { render, staticRenderFns } from "./Alerts.global.vue?vue&type=template&id=9ed89dc4&lang=pug&"
import script from "./Alerts.global.vue?vue&type=script&lang=ts&"
export * from "./Alerts.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports